import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { sanitizeExtraAttributes } from './analytics-helpers';
export var getStreamFetchErrorEventPayload = function getStreamFetchErrorEventPayload(error, source) {
  if (error instanceof Error) {
    var _error$stack;
    return {
      action: 'failed',
      actionSubject: 'aiAnswerDialogStreamFetch',
      source: source,
      eventType: 'track',
      attributes: {
        errorName: error.name,
        errorMessage: error.message,
        errorStack: ((_error$stack = error.stack) === null || _error$stack === void 0 ? void 0 : _error$stack.split('\n').at(1)) || ''
      }
    };
  }
  if (error instanceof Object && 'error' in error) {
    var _error$error$stack;
    return {
      action: 'failed',
      actionSubject: 'aiAnswerDialogStreamFetch',
      source: source,
      eventType: 'track',
      attributes: {
        errorName: error.error instanceof Error ? error.error.name : '',
        errorMessage: error.error instanceof Error ? error.error.message : typeof error === 'string' ? error : '',
        errorStack: error.error instanceof Error ? (_error$error$stack = error.error.stack) === null || _error$error$stack === void 0 ? void 0 : _error$error$stack.split('\n').at(1) : '',
        reason: 'reason' in error ? error.reason : '',
        details: 'details' in error ? error.details : ''
      }
    };
  }
  return {
    action: 'failed',
    actionSubject: 'aiAnswerDialogStreamFetch',
    source: source,
    eventType: 'track',
    attributes: {
      reason: error instanceof Object && 'reason' in error ? error.reason : '',
      details: error instanceof Object && 'details' in error ? error.details : ''
    }
  };
};
export var getNonStreamFetchErrorEventPayload = function getNonStreamFetchErrorEventPayload(error, source) {
  var _error$stack2;
  return {
    action: 'failed',
    actionSubject: 'aiAnswerDialogNonStreamFetch',
    source: source,
    eventType: 'track',
    attributes: {
      errorName: error instanceof Object && 'name' in error ? error.name : '',
      errorMessage: error instanceof Object && 'message' in error ? error.message : '',
      errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? (_error$stack2 = error.stack) === null || _error$stack2 === void 0 ? void 0 : _error$stack2.split('\n').at(1) : ''
    }
  };
};
export var updateDefinitionErrorPayload = function updateDefinitionErrorPayload(error, commonAttributes) {
  var _error$stack3;
  var extraAttributes = commonAttributes.extraAttributes,
    source = commonAttributes.source;
  return {
    action: 'failed',
    actionSubject: 'aiCuratedDefinitionUpdate',
    source: source,
    eventType: 'track',
    attributes: _objectSpread(_objectSpread({}, sanitizeExtraAttributes(extraAttributes)), {}, {
      errorName: error instanceof Object && 'name' in error ? error.name : '',
      errorMessage: error instanceof Object && 'message' in error ? error.message : '',
      errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? (_error$stack3 = error.stack) === null || _error$stack3 === void 0 ? void 0 : _error$stack3.split('\n').at(1) : ''
    })
  };
};